export default {
  title: "Mettre à jour l'heure de dépôt",
  labels: {
    dropoff_time: 'Heure de dépôt',
    confirmed: 'Heure confirmée :',
    new_time: 'Nouvelle heure :',
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    success: "L'heure de dépôt a été mise à jour avec succès",
    failed_to_save: "Échec de l'enregistrement des modifications",
  },
  alerts: {
    dropoff_time_info:
      "L'heure actuelle et la nouvelle heure sont dans le fuseau horaire {{restaurantName}} {{timezone}}",
  },
};
